import {
  READ_ACTION,
  SUBSCRIPTIONS_STATISTICS,
  KPI,
  INVOICING_RANKING,
  SPECIALIST_CONSULTANT_RANKING,
  PEFORMANCE_EVOLUTION,
  CAMPAIGN,
  RANKING_COMPROMISSOS_MENU,
  DNA_RANKING_MENU,
  CAMPAIGN_KPI,
  REALIZED_OKR,
  FUNNEL_FINANCIAL_PLNANNING,
  BI_REPORTS_PN_MENU,
} from "@/constants/resources";

export default [
  {
    title: "Indicadores PN",
    icon: "none",
    children: [
      {
        title: "OKRs",
        route: "okr-dashboard",
        icon: "CompassIcon",
        resource: REALIZED_OKR,
        action: READ_ACTION,
      },
      {
        // O Faturometro do menu e o 2.0 -- a leitura por estrutura
        // hierarquica. A tela antiga continua alcancavel pela rota /kpi
        // enquanto nao for removida, mas deixa de ser o caminho padrao: e
        // para o 2.0 que as regras novas vao passar a nascer.
        title: "Faturômetro",
        route: "kpi-tree",
        icon: "ActivityIcon",
        resource: KPI,
        action: READ_ACTION,
      },
      {
        title: "Ranking compromissos",
        route: "kpi-ranking-appoiments",
        icon: "CalendarIcon",
        resource: RANKING_COMPROMISSOS_MENU,
        action: READ_ACTION,
      },
      {
        title: "Ranking faturamento",
        route: "kpi-ranking-invoicing",
        icon: "BarChart2Icon",
        resource: INVOICING_RANKING,
        action: READ_ACTION,
      },
      {
        title: "Ranking de Excelência",
        route: "kpi-ranking-of-excellence",
        icon: "TrendingUpIcon",
        resource: SPECIALIST_CONSULTANT_RANKING,
        action: READ_ACTION,
      },
      {
        title: "Ranking DNA Campeão",
        route: "kpi-ranking-dna",
        icon: "AwardIcon",
        resource: DNA_RANKING_MENU,
        action: READ_ACTION,
      },
      {
        title: "PNC+ Colaboração",
        route: "kpi-pnc-colaboracao",
        icon: "UsersIcon",
        resource: DNA_RANKING_MENU,
        action: READ_ACTION,
      },
      {
        title: "KPI do Lead ao Plano Financeiro",
        route: "funnel-financial-planning",
        icon: "FilterIcon",
        resource: FUNNEL_FINANCIAL_PLNANNING,
        action: READ_ACTION,
      },
      {
        title: "Estatísticas de assinatura",
        route: "kpi-subscriptions-statistics",
        icon: "PieChartIcon",
        resource: SUBSCRIPTIONS_STATISTICS,
        action: READ_ACTION,
      },
      {
        title: "Evolução de performance",
        route: "kpi-evolucao-performance",
        icon: "LoaderIcon",
        resource: PEFORMANCE_EVOLUTION,
        action: READ_ACTION,
      },
      {
        title: "Mapa de calor DNA Campeão",
        route: "kpi-mapa-calor-dna",
        icon: "MapIcon",
        resource: PEFORMANCE_EVOLUTION,
        action: READ_ACTION,
      },
      {
        title: "Campanhas",
        route: "campanhas",
        icon: "ShoppingBagIcon",
        resource: CAMPAIGN_KPI,
        action: READ_ACTION,
      },
      {
        title: "Relatórios BI",
        route: "bi-report-list",
        icon: "PieChartIcon",
        resource: BI_REPORTS_PN_MENU,
        action: READ_ACTION,
      },
    ],
  },
];
